import replaceCalcSpaces from "./replace-calc-spaces";
import replaceOptionColons from "./replace-option-colons";
import replaceResolutions from "./replace-resolutions";
import normalizeCharacterSpaces from "./normalize-character-spaces";
import replaceNestedSpaces from "./replace-nested-spaces";
import replaceOptionCommas from "./replace-option-commas";
import replaceComposition from "./replace-composition";
import replaceTriggers from "./replace-triggers";
import replaceCommas from "./replace-commas";
import checkNestedResolutions from "./check-nested-resolutions";

/**
 * Process single (non-timeline) string
 * @example `animate:rotate($value3 <duration:[2s xl::5s], easing:bezier(0.3,0,0.7,0)>)`
 * @param {String} input
 * @returns {String}
 */
const optimizeSingleAttribute = (input) => {
  const commas = replaceCommas(input);
  const resolutions = replaceResolutions(commas);
  const normalized = normalizeCharacterSpaces(resolutions);
  const options = replaceOptionColons(normalized);
  const calc = replaceCalcSpaces(options);
  const composition = replaceComposition(calc);
  const nested = replaceOptionCommas(composition);
  const spaces = replaceNestedSpaces(nested);
  const triggers = replaceTriggers(spaces);

  const hasNestedResolutions = checkNestedResolutions(triggers, input);

  if (hasNestedResolutions) {
    return "";
  }

  return triggers;
};

export default optimizeSingleAttribute;
